
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";

declare const EyeDropper: any; // TODO: Remove once typescript adds support for it.
@Component({
  components: { Icon }
})
export default class EyeDropperComponent extends Vue {
  get supported() {
    return "EyeDropper" in window;
  }

  async addColor() {
    try {
      const eyeDropper = new EyeDropper();
      const { sRGBHex } = await eyeDropper.open();
      this.emit(sRGBHex);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  emit(newColor: string) {
    this.$emit("input", newColor);
  }
}
